import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const getters={
  getSelectedS: state => {
    return state.selected;
  }
};
const state={
  selected: 'course'
}
const store = new Vuex.Store({
  // 定义状态
  state,
  getters,
  mutations:{
    newSelected(state,msg){
      state.selected = msg;
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js